export default "__VITE_ASSET__RtFaM98O__"